/*
** helpers 3 dimensions -- random funcs for Squish
** Copyright (C) 2026-2026 Tactile Interactive, all rights reserved
*/

//import {mat4} from 'gl-matrix';

// wtf is wrong with this?!?!?!
const _ = (n) => {
	if (typeof n != 'number' || n == undefined) {
		console.error(`undefined n`);
		//debugger;
		return 'undefined n';
	}
	return n.toFixed(4).padStart(9, ' ')
};

export function dump4x4(title, matrix) {
	if (!matrix){
		dblog(`⣿⣿⣿mat: ${title}, matrix is null`);
		return;
	}
	if (matrix.constructor.name != 'Float32Array' || 16 != matrix.length) {
		dblog(`⣿⣿⣿mat: ${title} matrix, class ${matrix.constructor.name} len=${matrix.length} is not a correct typed array:`,
			typeof matrix, matrix.constructor.name, matrix.length);
	}

	//console.warn(matrix);

	dblog(`⣿⣿⣿  mat: ${title}
	${_(matrix[0])} + ${_(matrix[1])} + ${_(matrix[2])} + ${_(matrix[3])}
	${_(matrix[4])} + ${_(matrix[5])} + ${_(matrix[6])} + ${_(matrix[7])}
	${_(matrix[8])} + ${_(matrix[9])} + ${_(matrix[10])} + ${_(matrix[11])}
	${_(matrix[12])} + ${_(matrix[13])} + ${_(matrix[14])} + ${_(matrix[15])}` );
}

export function formatXYZ(which, orient) {
	if (!orient){
		dblog(`⣿⣿⣿ 🌔 bad orient: ${title}, as passed: `, orient);
		return;
	}
	// which is like 'Pos' for pposition nums

	return `${_(orient.xPos)}  ${_(orient.yPos)}  ${_(orient.zPos)} `;

	// ┑┎
	//${title}, ${title},
}

export function dumpOrient(title, orient) {
	if (!orient){
		dblog(`⣿⣿⣿ 🌔 bad orient: ${title}, as passed: `, orient);
		return;
	}
	dblog(`action: ,${formatXYZ('Ang', orient)}, 'ↀ', ${formatXYZ('Pos', orient)} `);


	//	+` ┑┎  ${_(orient.xPos)}  ${_(orient.yPos)}  ${_(orient.zPos)}  `);

	// ┑┎
	//${title}, ${title},
}

